'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
require('./Form.Context.Locale.js');

/**
 * Validator error type guard.
 */ function isValidationError(message) {
    return message != null && typeof message === 'object' && 'key' in message;
}
/**
 * Create form context.
 */ const FormContext = /*#__PURE__*/ react.createContext({
    /**
     * Fallback to the default message.
     */ getError: (error)=>{
        return isValidationError(error?.message) ? error?.message.key : error?.message ?? error?.type;
    }
});
/**
 * Form Context Provider.
 */ const FormProvider = ({ children, onFormSubmit, locale, ...props })=>{
    // Convert RHF errors to key/values
    const getError = react.useCallback((error)=>{
        // Resolve mapped key/value validators
        if (error?.message && isValidationError(error.message)) {
            return props.translate?.(error?.message);
        }
        // Resolve unmapped validators
        if (error?.type != null) {
            // In the case of type error, we have to the type error field
            if (error.type === 'typeError' && typeof error.types?.typeError === 'string') {
                return props.translate?.({
                    key: error.types.typeError
                });
            }
            // For any other case
            return props.translate?.({
                key: error.type
            });
        }
    }, [
        props
    ]);
    // Memorize values
    const value = react.useMemo(()=>({
            getError,
            onFormSubmit,
            locale
        }), [
        getError,
        onFormSubmit,
        locale
    ]);
    return jsxRuntime.jsx(FormContext.Provider, {
        value: value,
        children: children
    });
};

exports.FormContext = FormContext;
exports.FormProvider = FormProvider;
//# sourceMappingURL=Form.Context.js.map
